import React from 'react';
export function CTASection() {
  return <section className="bg-white py-[120px] px-8" id="contact" data-id="element-13">
      <div className="max-w-[800px] mx-auto text-center section-reveal" data-id="element-14">
        <h2 className="font-optima font-semibold text-[48px] md:text-[64px] text-charcoal mb-6" data-id="element-15">
          Visit Glenlofty
        </h2>

        <p className="font-optima text-[20px] text-charcoal/90 leading-[1.8] mb-10" data-id="element-16">
          We love to hear from fellow wine lovers. Whether you have a question,
          want to plan a visit, or simply want to say hello, please get in
          touch.
        </p>

        <button className="bg-charcoal text-white px-10 py-4 rounded-[8px] uppercase text-[16px] font-semibold tracking-wide-btn hover:bg-gold transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-17">
          Contact Us
        </button>
      </div>
    </section>;
}